import X from '@/assets/icons/x.svg';
import { Loader } from '@/components/common/loader';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { ScrollArea } from '@/components/ui/scroll-area';
import { getMultidietPopup } from '@/features/multidiet-picker/api/get-cms-popup';
import { useMultidietPopup } from '@/features/multidiet-picker/api/hooks/use-multidiet-popup';
import { MultidietPicker } from '@/features/multidiet-picker/components/multidiet-picker';
import { MultidietPopupType } from '@/features/multidiet-picker/types/multidiet-popup.type';
import { MultidietPickerType } from '@/features/static-builder/types/multidiet-picker.type';
import { useSearchParams } from 'next/navigation';
import React, { Suspense, useEffect, useState } from 'react';

export const MultidietPickerPopup = ({
  setOpen,
  open,
  children,
  data,
}: {
  setOpen: (open: boolean) => void;
  open: boolean;
  children: React.ReactNode;
  data?: MultidietPickerType;
}) => {
  const params = useSearchParams();
  const { data: popupData, isLoading } = useMultidietPopup({
    options: {
      retry: 3,
    },
  });

  useEffect(() => {
    if (open) {
      setOpen(false);
    }
  }, [params]);

  return (
    <Dialog modal={true} onOpenChange={setOpen} open={open}>
      <DialogTrigger asChild className=''>
        {children}
      </DialogTrigger>
      <DialogTitle className='hidden' />
      <DialogContent
        closeButton={false}
        className='gap-0 p-0 max-h-svh md:max-h-[calc(100svh-100px)] max-md:w-full max-md:max-w-full md:min-w-[900px] flex flex-col'
      >
        <DialogDescription className='hidden' />
        <div className='h-full overflow-scroll'>
          <DialogClose className='absolute right-4 lg:right-10 top-4 md:top-10 lg:top-8 bg-white rounded-full p-1'>
            <X className='h-6 w-6' />
          </DialogClose>
          {!isLoading && popupData?.data ? (
            <MultidietPicker data={popupData.data.attributes} layout='popup' />
          ) : (
            <Loader />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
